export { default as VapsFeatureCarCare } from './lib/vaps-feature-car-care'
